import { Button, Popconfirm, Space, Tooltip } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { t } from "i18next";

type EditDeleteActionsProps = {
  onEdit?: () => void;
  loadingEdit?: boolean;
  onDelete?: () => void;
  loadingDelete?: boolean;
};

function EditDeleteActions(props: EditDeleteActionsProps) {
  return (
    <Space size={4}>
      <Tooltip title={t("button.edit")}>
        <Button
          type="text"
          size="small"
          icon={<EditOutlined />}
          aria-label={t("button.edit")}
          onClick={props.onEdit}
          loading={props.loadingEdit}
        />
      </Tooltip>
      <Popconfirm
        title={t("button.delete")}
        okText={t("button.delete")}
        okButtonProps={{ danger: true, loading: props.loadingDelete }}
        cancelText={t("button.cancel")}
        onConfirm={props.onDelete}
        disabled={!props.onDelete || props.loadingDelete}
      >
        <Tooltip title={t("button.delete")}>
          <Button
            danger
            type="text"
            size="small"
            icon={<DeleteOutlined />}
            aria-label={t("button.delete")}
            loading={props.loadingDelete}
            onClick={(e) => {
              // Let Popconfirm control the action; prevent accidental row click.
              e.preventDefault();
              e.stopPropagation();
            }}
          />
        </Tooltip>
      </Popconfirm>
    </Space>
  );
}

export default EditDeleteActions;
